<template>
    <div class="fill-height of-y d-flex align-center mr-2" >
        <div class="ml-4 text-h5 font-weight-light">
            Leave
        </div>

        <div class="flex-grow-1">
            <slot></slot>
        </div>

        <v-scale-transition>
            <div style="max-width: 300px" v-if="$store.state.ref.leave.tabIndex === 1">
                <v-text-field
                    placeholder="Search"
                    hide-details
                    class="pa-0 ma-0"
                    color="primary"
                    prepend-inner-icon="mdi-magnify"
                    solo
                    dense
                    v-model="$store.state.ref.leave.filterStr"
                ></v-text-field>
            </div>
        </v-scale-transition>

        <app-toolbar-month-selector v-model="$store.state.ref.leave.leaveDate"></app-toolbar-month-selector>

        <v-btn
            color="primary"
            small
            outlined
            @click="$store.state.ref.leave.showAdd = true"
        >
            <v-icon small left>mdi-plus</v-icon>
            Add leave record
        </v-btn>
    </div>
</template>

<script>
import AppEmployeeImport from "@/components/Employees/AppEmployeeImport.vue";
import AppToolbarMonthSelector from "@/components/Shared/AppToolbarMonthSelector.vue";
export default {
    components: {
        AppToolbarMonthSelector,
        AppEmployeeImport

    },
    props: {
        shown: Boolean
    },
    data() {
        return {
            showImportEmployees: false
        }
    },
    watch: {

    },
    methods: {

    },
    computed: {

    },
}
</script>

<style scoped>

</style>